import { render } from "./FormButtonSelect.vue?vue&type=template&id=ca0b8388"
import script from "./FormButtonSelect.vue?vue&type=script&lang=js"
export * from "./FormButtonSelect.vue?vue&type=script&lang=js"

import "./FormButtonSelect.vue?vue&type=style&index=0&id=ca0b8388&lang=scss"
script.render = render

export default script